<template>
  <div class="page height-full">
    <md-dialog :md-active.sync="showDialog" class="md-dialog-container">
      <md-dialog-title>New User</md-dialog-title>
      <md-dialog-content class="dialog-content">
        <b-form-group
          id="input-group-1"
          label="First Name:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="form.name"
            type="text"
            required
            placeholder="First name"
          />
        </b-form-group>

        <b-form-group id="input-group-2" label="Last Name:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="form.familyName"
            required
            placeholder="Last name"
          />
        </b-form-group>

        <b-form-group id="input-group-4" label="Email:" label-for="input-4">
          <b-form-input
            id="input-4"
            v-model="form.email"
            required
            placeholder="Email"
          />
        </b-form-group>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button type="reset" class="md-primary" @click="close">Close</md-button>
        <md-button type="submit" class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="showEditDialog" v-if="selectedUser != null"class="md-dialog-container">
      <md-dialog-title>Edit Role</md-dialog-title>
      <md-dialog-content class="dialog-content">
        <b-form-group
          id="input-group-1"
          label="First Name:"
          label-for="input-1"
        >
          <p>{{selectedUser.givenName}}</p>
        </b-form-group>

        <b-form-group id="input-group-2" label="Last Name:" label-for="input-2">
          <p>{{selectedUser.familyName}}</p>
        </b-form-group>

        <b-form-group id="input-group-4" label="Email:" label-for="input-4">
          <p>{{selectedUser.email}}</p>
        </b-form-group>

        <b-form-group id="input-group-4" label="Role:" label-for="input-4">
          <b-form-select v-model="form.role" :options="options"></b-form-select>
        </b-form-group>

      </md-dialog-content>
      <md-dialog-actions>
        <md-button type="reset" class="md-primary" @click="close">Close</md-button>
        <md-button type="submit" class="md-primary" @click="updateRole">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
    <app-header title="Users"/>
    <b-card>
      <div>
        <div><a href="#" @click="goBack" style="float: left;">&larr; Go Back</a></div>
        <b-button variant="primary" class="brand-purple compose-btn" @click="showDialog = true" style="float: right; margin-bottom: 16px;">
          Add Users
        </b-button>
        <b-table hover :items="items" :fields="fields">
          <template v-slot:cell(actions)="data">
            <div class="action-container" v-if="isOwner(data) == false">
             <b-dropdown
               variant="link"
               size="lg"
               toggle-class="text-decoration-none"
               no-caret
               right
             >
               <template slot="button-content">
                 <b>⋮</b>
               </template>
               <b-dropdown-item class="delete" @click="deleteUser(data)"><b-icon-trash></b-icon-trash><span>Remove User</span></b-dropdown-item>
             </b-dropdown>
            </div>
          </template>
        </b-table>
        <spinner v-if="isLoading"></spinner>
      </div>
    </b-card>
  </div>
</template>

<script>

  import Constants from '../../Constants'
  import axios from 'axios'
  import Spinner from '../common/Spinner'

  export default {
    name: "Users",
    components: {
      Spinner
    },
    data: () => {
      return {
        items: [],
        isLoading: false,
        selectedUser: null,
        form: {
          name: '',
          ph: '',
          familyName: '',
          country: '',
          phone: '',
          email: '',
          role: ''
        },
        fields: ['givenName', 'familyName', 'email', 'role', 'actions'],
        showDialog: false,
        showEditDialog: false,
        options: [
          { value: 'admin', text: 'Admin - All Access' },
          { value: 'agent', text: 'Agent - Send and receive messages' }
        ]
      }
    },
    methods: {
      goBack() {
        const id = this.$route.params.id
        this.$router.push('/accounts/' + id)
      },
      deleteUser: function(data) {
        this.isLoading = true
        const id = data.item.sk.split('|')[1]
        axios.delete(Constants.API_URL + '/account/users/' + id)
          .then(response => {
            this.getUsers()
          }).catch(err => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
          })
      },
      editUser: function(data) {
        console.log(data)
        this.selectedUser = data.item
        this.showEditDialog = true
      },
      updateRole: function(data) {
        const userId = this.selectedUser.sk.split('|')[1]
        this.isLoading = true
        axios.put(Constants.API_URL + "/account/users/" + userId, {role: this.form.role})
          .then((response) => {
            swal('Role Updated', 'Successfully updated user role to ' + this.form.role, 'success')
            this.close()
            this.getUsers()
          }).catch((err) => {
            swal('Error', 'Error Updating Role', 'error')
          }).then(() => {
            this.isLoading = false
          })
      },
      updatePhone(data) {
        this.form.phone = data.nationalNumber
        this.form.country = data.countryCallingCode
      },
      isOwner: function(data) {
        return data.item.role == "owner"
      },
      getUsers() {
        this.isLoading = true
        const id = this.$route.params.id
        axios
          .get(Constants.API_URL + '/accounts/' + id + '/clients')
          .then(response => {
            console.log(response);
            this.isLoading = false
            this.items = response.data.Items.map((item) => {
              item.phoneNumber = Constants.FORMAT_PHONE_NUMBER(item.sk.split("|")[1])
              return item
            })
            console.log(items)
          }).catch((err) => {
            console.log(err)
            this.isLoading = false
        })
      },
      reset() {
        this.form.country = "";
        this.form.name = "";
        this.form.ph = "";
        this.form.familyName = "";
        this.form.phone = "";
      },
      close() {
        this.reset();
        this.showDialog = false
      },
      save() {
        const params = {
          givenName: this.form.name,
          familyName: this.form.familyName,
          email: this.form.email,
        }

        console.log(params)
        const id = this.$route.params.id
        this.isLoading = true
        axios
          .post(Constants.API_URL + '/accounts/' + id + '/clients', params)
          .then(response => {
            console.log(response);
            this.close()
          }).catch((err) => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
            this.getUsers()
          })
      }
    },
    mounted() {
      this.getUsers()
    }
  }
</script>

<style scoped>
  .dialog-content {
    max-height: 600px;
    width: 500px;
  }

  .country-content {
    width: 100%;
  }

  .action-container {
    margin-top: -10px;
  }

  .delete {
    color: red;
  }

  .delete svg {
    margin-right: 8px;
    color: red;
  }

  .delete span {
    color: red;
  }

  .edit svg {
    margin-right: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/Users.vue